import { StyleSheet } from 'react-native'
import { ThemedSizes, ThemedValues } from 'styles/themed'
import { colorList } from 'utils/colors'

export const UserAvatarStyles = StyleSheet.create({
	avatarContainer: {
		position: 'relative',
		backgroundColor: '#ccc',
		borderRadius: ThemedValues.borderRadius,
		justifyContent: 'center',
		alignItems: 'center',
	},
	avatarText: {
		color: 'white',
	},
	avatarImage: {
		borderRadius: ThemedValues.borderRadius,
		width: 'auto',
		height: 'auto'
	},
	
	avatarWithEro: {
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 0,
	},
	avatarWithConfidant: {
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 0,
	},
	
	highlight: {
		//borderWidth: 2,
		borderColor: colorList.PRIMARY.transparent,
	}
});

export const UserAvatarEroStyles = StyleSheet.create({
	container: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: colorList.RED.primary,
		borderBottomLeftRadius: 6,
		borderBottomRightRadius: 6,
		padding: 2
	},
	withConfidant: {
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 0,
	},
	icon: {
		fontSize: 9,
		color: colorList.WHITE.primary,
		marginRight: 2
	},
	text: {
		fontSize: 8,
		color: colorList.WHITE.primary
	}
});

export const UserAvatarConfidantStyles = StyleSheet.create({
	container: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: colorList.BLUE.primary,
		borderBottomLeftRadius: 6,
		borderBottomRightRadius: 6,
		padding: 2,
	},
	text: {
		textAlign: 'center',
		fontSize: 6,
		color: colorList.WHITE.primary
	}
});

export const UserAvatarSizeStyles = {
	[ThemedSizes.XXS]: StyleSheet.create({
		avatarContainer: {
			width: 20,
			height: 20
		},
		avatarImage: {
			width: 20,
			height: 20
		},
		avatarText: {
			fontSize: 10
		}
	}),
	[ThemedSizes.XS]: StyleSheet.create({
		avatarContainer: {
			width: 30,
			height: 30
		},
		avatarImage: {
			width: 30,
			height: 30
		},
		avatarText: {
			fontSize: 12
		}
	}),
	[ThemedSizes.S]: StyleSheet.create({
		avatarContainer: {
			width: 45,
			height: 45
		},
		avatarImage: {
			width: 45,
			height: 45
		},
		avatarText: {
			fontSize: 14
		}
	}),
	[ThemedSizes.M]: StyleSheet.create({
		avatarContainer: {
			width: 60,
			height: 60
		},
		avatarImage: {
			width: 60,
			height: 60
		},
		avatarText: {
			fontSize: 18
		}
	}),
	[ThemedSizes.L]: StyleSheet.create({
		avatarContainer: {
			width: 120,
			height: 120
		},
		avatarImage: {
			width: 120,
			height: 120
		},
		avatarText: {
			fontSize: 35
		}
	}),
	[ThemedSizes.XL]: StyleSheet.create({
		avatarContainer: {
			width: 180,
			height: 180
		},
		avatarImage: {
			width: 180,
			height: 180
		},
		avatarText: {
			fontSize: 50
		}
	})
}
